import PropTypes from 'prop-types';
import { Icon, TRAVEL_AIRPLANE } from '@bwoty-web/styleguide';
import './flightTimeOption.scss';

const FlightTimeOption = ({
  fill,
  label,
  flightTimeKey,
  active,
  onSelectFlightTime,
}) => {
  return (
    <div
      tabIndex="0"
      role="button"
      onClick={() => {
        onSelectFlightTime(flightTimeKey);
      }}
      onKeyDown={(e) => {
        if (e.keycode === 13) {
          onSelectFlightTime(flightTimeKey);
        }
      }}
      className={`vf-flight-time-option vf-filter-option ${
        active ? 'vf-filter-option--active' : ''
      }`}
    >
      <div className="vf-flight-time-option__icon-wrapper">
        <span
          className={`vf-airplane__stripe vf-airplane__stripe-1 vf-airplane__stripe-1-${fill} ${
            active ? `vf-airplane__stripe-1-${fill}-animate` : ''
          }`}
        />
        <span
          className={`vf-airplane__stripe vf-airplane__stripe-2 vf-airplane__stripe-2-${fill} ${
            active ? `vf-airplane__stripe-2-${fill}-animate` : ''
          }`}
        />
        <Icon
          fill="rgb(61, 103, 120)"
          className={`vf-flight-time-option__icon vf-flight-time-option__icon-${fill} ${
            active ? `vf-flight-time-option__icon-${fill}-animate` : ''
          }`}
          path={TRAVEL_AIRPLANE}
          size="l"
        />
      </div>
      <button
        type="button"
        className="vf-filter-option__button"
        data-test={`${flightTimeKey.toLowerCase()}-button${
          active ? '-selected' : ''
        }`}
      >
        {label}
      </button>
    </div>
  );
};

FlightTimeOption.propTypes = {
  flightTimeKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fill: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onSelectFlightTime: PropTypes.func.isRequired,
};

export default FlightTimeOption;
